"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Button_module_css_1 = __importDefault(require("./Button.module.css"));
const Button = ({ size = 'sm', color = 'primary', variant = 'contained', processing = false, disabled = false, fullWidth = false, className, children, ...props }) => {
    return (react_1.default.createElement("button", Object.assign({}, props, { disabled: disabled || processing, className: classnames_1.default(className, Button_module_css_1.default.root, Button_module_css_1.default[`size-${size}`], Button_module_css_1.default[`color-${color}`], Button_module_css_1.default[`variant-${variant}`], {
            [Button_module_css_1.default.processing]: processing,
            [Button_module_css_1.default.disabled]: disabled,
            [Button_module_css_1.default.fullWidth]: fullWidth
        }) }),
        react_1.default.createElement("span", { className: Button_module_css_1.default.wrapper }, react_1.default.Children.map(children, child => {
            if (!child)
                return null;
            return react_1.default.createElement("span", { className: Button_module_css_1.default.content }, child);
        }))));
};
exports.Button = Button;
//# sourceMappingURL=Button.js.map